import { proxy } from "valtio";
import {
  PackageBundle,
  PackageBundleBooking,
  PackageBundleBookingAppliedStatus,
  PackageBundleBookingOwnerContext,
} from "../types/package.bundle";
import {
  LovewallSubscription,
  LovewallSubscriptionPlanDuration,
  LovewallSubscriptionPlanKind,
} from "../types/subscription";
import { getAllPackageBundles } from "../apis/package-bundle/get.all.package.bundles";
import { getAllPackageBundleBookings } from "../apis/package-bundle/get.all.package.bundle.bookings";
import { getEventPlannerWeddingsWithCreditsAndSubscriptions } from "../apis/package-bundle/get.event.planner.weddings.with.credits.and.subscriptions";
import { Wedding } from "../types/wedding";
import { InAppCredits } from "../types/mailcredit";

export const createDefaultPackageBundle = (): PackageBundle => ({
  _id: "",
  amount: 0,
  createdAt: "",
  description: "",
  inAppPackageID: "",
  loveWallSubscriptionPlanID: "",
  inAppPackage: {
    _id: "",
    name: "",
    credits: 0,
    amount: 0,
    createdAt: null as any,
    updatedAt: null as any,
  },
  lovewallSubscriptionPlan: {
    _id: "",
    amount: 0,
    createdAt: null as any,
    duration: "" as LovewallSubscriptionPlanDuration,
    name: "" as LovewallSubscriptionPlanKind,
    updatedAt: null as any,
    maxLoveWallPosts: 0,
  },
  name: "",
  updatedAt: "",
});

export const createDefaultPackageBundleBooking = (): PackageBundleBooking => ({
  _id: "",
  packageBundleID: "",
  accountID: "",
  weddingID: "",
  ownerID: "",
  ownerCtx: PackageBundleBookingOwnerContext.EventPlanner,
  appliedStatus: PackageBundleBookingAppliedStatus.NotApplied,
  loveWallSubscriptionID: "",
  createdAt: new Date(),
  updatedAt: new Date(),
});

type NewPackageBundleStore = {
  data: {
    isPacakgeBundleDrawerOpen: boolean;
    bundles: PackageBundle[];
    appliedBookings: PackageBundleBooking[];
    notAppliedBookings: PackageBundleBooking[];
    weddings: (Wedding & {
      inAppCredits: InAppCredits;
      lovewallSubscription?: LovewallSubscription;
    })[];
  };
};

export const PackageBundleStore = proxy<NewPackageBundleStore>({
  data: {
    isPacakgeBundleDrawerOpen: false,
    bundles: [],
    appliedBookings: [],
    notAppliedBookings: [],
    weddings: [],
  },
});

export const fetchPackageBundlesAndBookings = () => {
  getAllPackageBundles({
    onCompleted(res) {
      PackageBundleStore.data = {
        ...PackageBundleStore.data,
        bundles: res.data,
      };
    },
    onError(err) {
      console.error(err);
    },
  });
  getAllPackageBundleBookings(
    {
      query: {
        appliedStatus: PackageBundleBookingAppliedStatus.Applied,
      },
      onCompleted(res) {
        PackageBundleStore.data = {
          ...PackageBundleStore.data,
          appliedBookings: res.data,
        };
      },
      onError(err) {
        console.error(err);
      },
    },
    { bypassCache: true },
  );
  getAllPackageBundleBookings(
    {
      query: {
        appliedStatus: PackageBundleBookingAppliedStatus.NotApplied,
      },
      onCompleted(res) {
        PackageBundleStore.data = {
          ...PackageBundleStore.data,
          notAppliedBookings: res.data,
        };
      },
      onError(err) {
        console.error(err);
      },
    },
    { bypassCache: true },
  );
  getEventPlannerWeddingsWithCreditsAndSubscriptions(
    {
      onCompleted(res) {
        PackageBundleStore.data = {
          ...PackageBundleStore.data,
          weddings: res.data,
        };
      },
      onError(err) {
        console.error(err);
      },
    },
    { bypassCache: true },
  );
};
